import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const fetchLatestVideosDone = (_, { payload }) => {
    return [
        ...payload
    ]
}

  // const clearFaqsNotesDocumentsDone = () => {
  //   return []
  // }
  const initialState = [];

export default createReducer(initialState, {
    [TYPES.FETCH_VIDEOS_DONE]: fetchLatestVideosDone,
    // [TYPES.CLEAR_FAQ_NOTES_DOCUMENTS]: clearfetchLatestVideosDone
  });
